<div class="wrapper">
  <div class="left">
    <span class="content">
      <ng-content></ng-content>
    </span>
  </div>
  @if (rightTemplate) {
    <div class="right">
      <ng-container [ngTemplateOutlet]="rightTemplate"></ng-container>
    </div>
  }
</div>
